<template>
	<section class="Search0002">
		<el-row :gutter="0" class="SearchHead">
			<router-link to="/sp/0002" class="Router__To__Destination">
				<i class="el-icon-close"></i>
			</router-link>
			<el-col :span="6">
				<!-- /*** Change by SS for backlog Id: 1430 */ -->
				<span class="SearchSpan">記事検索</span>
			</el-col>
			<el-col :span="12">
				<img
					src="../../../assets/image/logo-new.png"
					alt="logo"
					class="ElnetLogo"
				/>
			</el-col>
			<el-col :span="6"></el-col>
		</el-row>
		<el-row class="SearchBody">
			<el-form ref="form" :model="form">
				<!-- /*** Change by CK for backlog Id: 1430 */ added label for input fields-->
				<el-form-item label="キーワード">
					<el-input v-model="form.value" placeholder="キーワード..." :disabled="articleMedia == 1"></el-input>
				</el-form-item>
				<el-form-item label="検索条件">
					<el-select v-model="SelectValue1" @change="searchConditionChange($event)">
						<el-option
							v-for="item in getsearchCondition"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="記事の期間">
					<v-date-picker
						mode="range"
						v-model="range"
						locale="ja"
						class="SelectDateRange"
						:inputProps="{readOnly:true}"
					/>
				</el-form-item>
				<el-form-item label="媒体名で検索">
					<el-input v-model="form2.value"  placeholder="媒体名..." :disabled="articleMedia == 1"></el-input>
				</el-form-item>
				<!-- <router-link to="/sp/" class="Router__To__Destination"> -->
				<el-button type="primary" class="SearchBtn" @click="articleSearch"
					>検索</el-button
				>
				<!-- </router-link> -->
			</el-form>
		</el-row>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import VCalendar from "v-calendar-ie11";
//import Common from "../../../common/CommonFunc.js";
import router from "../../../router";

Vue.use(VCalendar);
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var FifteendaysBefore = CurrentDay - 15;
export default {
	name: "Search0002",
	props: [],
	mounted() {
		//Api call for get search dropdown data
		this.$store.dispatch("sp_Communication0001/getArticleSearch");
		this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
	},
	data() {
		return {
			range: {
				//start: new Date(2020, 2, FifteendaysBefore), // Jan 16th, 2018
				start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore), // Jan 16th, 2018
				end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
			},
			form: {
				value: ""
			},
			form2: {
				value: ""
			},
			SelectValue1: "",
			select_search_value: "",
			articleMedia: ""
		};
	},
	methods: {
		//Functions for getting value selected in search dropdown
		searchConditionChange($event) {
			this.$LogButtonEvent("0002","ChangeCondition");
			this.$LogMethodIN("0002","searchConditionChange");
			for (var j = 0; j < this.getsearchCondition.length; j++) {
				if ($event == this.getsearchCondition[j].value) {
					this.select_search_value = this.getsearchCondition[j]["value"];
				}
			}
			console.log(this.select_search_value);
			//if search dropdown is selected, clear and disable the keyword and media textbox
			if (this.select_search_value != "") {
				this.articleMedia = 1;
				this.form.value = "";
				this.form2.value = "";
			}
			this.$LogMethodOut("0002","searchConditionChange");
		},

		articleSearch() {
			this.$LogButtonEvent("0002","Search");
			this.$LogMethodIN("0002","articleSearch");			
			console.log(this.getSearchConditionKey)
			console.log(this.getThemeLoadCheck)
			//get the start date from the selected date
			var startDate = this.range.start;
			var sdate = new Date(startDate),
				smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
				sday = ("0" + sdate.getDate()).slice(-2);
			//convert the date format
			var startResult = [sdate.getFullYear(), smnth, sday].join("/");
			console.log(startResult);
			//get the end date from the selected date
			var endDate = this.range.end;
			var edate = new Date(endDate),
				emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
				eday = ("0" + edate.getDate()).slice(-2);
			//convert the date format
			// 2021/01/18 #10394 START
			//var endResult = [sdate.getFullYear(), emnth, eday].join("/");
			var endResult = [edate.getFullYear(), emnth, eday].join("/");
			// 2021/01/18 #10394 END
			console.log(endResult);
			// var searchKey = 1;
			this.$store.commit(
				"sp_Situation0001/setSearchValue",
				this.select_search_value
			);
			var defaultLoading = 0;
			console.log(this.getSearchConditionKey)
			console.log(this.getThemeLoadCheck)
			this.$store.commit("sp_Situation0001/setKeywordValue", this.form.value);
			this.$store.commit("sp_Situation0001/setMediaValue", this.form2.value);
			this.$store.commit("sp_Situation0001/setSearchStartDate", startResult);
			this.$store.commit("sp_Situation0001/setSearchEndDate", endResult);
			this.$store.commit('sp_Situation0001/setSearchConditionKey', 1);
			this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
			this.$store.commit("sp_Situation0001/setNewsWebCheck", 3);
			this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', defaultLoading);

			this.$store.commit('sp_Situation0001/nikkieArticledata', []);
			this.$store.commit('sp_Situation0001/setTotalNewsCount', 0);
			this.$store.commit('sp_Situation0001/setTotalNewsLabel', "新聞(0件)");
			
			this.$store.commit('sp_Situation0001/webArticleData', []);
			this.$store.commit('sp_Situation0001/setWebTotalNewsCount', 0);
			this.$store.commit('sp_Situation0001/setWebTotalLabel', "WEB(0件)");

      this.$store.commit('sp_Situation0001/magazineArticleData', []);
      this.$store.commit('sp_Situation0001/setMagazineTotalNewsCount', 0);
      this.$store.commit('sp_Situation0001/setMagazineTotalLabel', "雑誌(0件)");

			this.$store.commit("sp_Situation0001/setNewsSecondTabCheckboxValue", 0);
			this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);

			router.push({ name: "sp_0001" });
			this.$LogMethodOut("0002","articleSearch");
		}
	},
	computed: {
		...mapGetters("sp_Situation0001", ["getsearchCondition",
										"getSearchConditionKey",
										"getThemeLoadCheck"])
	},
	beforeCreate() {
		//Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
	}
};
</script>

<style scoped>
@import "0002.css";
@import "../../../assets/css/customStyle.css";
</style>
